import React, { useEffect } from 'react';
import { defineBlock, ChildrenBlockWithHTMLBoundary } from '@smartfire/js-block-engine';

const initWpForm = () => {
    if (window.wpforms) {
        window.wpforms.init();
    }
};

const WPFormsContainer = () => {
    useEffect(() => {
        window.addEventListener('load', initWpForm);
        return () => {
            window.removeEventListener('load', initWpForm);
        };
    }, []);

    return <ChildrenBlockWithHTMLBoundary />;
};

export default defineBlock({
    Block: WPFormsContainer,
    smartProps: {},
    setup: {
        title: 'WP Forms Container',
    },
});
